/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Archive_LabelInputs */

const en_filter_archive_label = /** @type {(inputs: Filter_Archive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived or not`)
};

/**
* | output |
* | --- |
* | "Archived or not" |
*
* @param {Filter_Archive_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const filter_archive_label = /** @type {((inputs?: Filter_Archive_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Archive_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_filter_archive_label(inputs)
});